import React from 'react';
import { WraperLegend, ButtonLegend, ButtonSpan, OvalLegend } from './styles';

let labels: Object = {
  "grip": "Grip",
  "scaption": "Scaption",
  "internalRotation": "IR",
  "externalRotation": "ER",
  "erIrRatio": "Shoulder Balance",
  "svr": "Strength Velocity Ratio",
  "totalStrength": "Total Strength",
  "freshTotalRatio": "Total Strength",
  "freshIRRatio": "IR",
  "freshERRatio": "ER",
  "freshScaptionRatio": "Scaption",
  "freshGripRatio": "Grip",
  "velocity": "Max Velocity",
}

export default ({ 
  handleLegend, 
  recoveryOptions,
  keyMetricsGraphic,
  setKeyMetricsGraphic
}: { 
  handleLegend: Function, 
  recoveryOptions: Object,
  keyMetricsGraphic: Array<Object>,
  setKeyMetricsGraphic: Function
}) => {
  const onClickItemLegend = (key: string) => {
    let newKeyMetricsGraphic = Object.assign({}, keyMetricsGraphic);
    newKeyMetricsGraphic[key].checked = !newKeyMetricsGraphic[key].checked;
    setKeyMetricsGraphic(newKeyMetricsGraphic)    
    setTimeout(() => {
      Object.keys(recoveryOptions).forEach(key => {
        if(recoveryOptions[key].checked) handleLegend(key)
      })
    }, 100)
  }

  return (
    <WraperLegend>
      {Object.keys(keyMetricsGraphic).map(key => {
        return (
          <ButtonLegend 
            type={'button'} 
            onClick={() => onClickItemLegend(key)}
            checked={keyMetricsGraphic[key].checked}
            key={`legend-${keyMetricsGraphic[key].id}`} 
          >
            <OvalLegend size={'9'} color={keyMetricsGraphic[key].legendColor} margin={'0px 4px'} />
            <ButtonSpan>{[labels[keyMetricsGraphic[key].name]]}</ButtonSpan>
          </ButtonLegend>
        )
      })}
    </WraperLegend>
  )
};
